{
  "es": {
    "unit": {
      "actions": {
        "bulk": {
          "activate": "Activar unidades",
          "allow_customer_issue_creation": "Permitir que los clientes creen incidencias",
          "block_customer_issue_creation": "Impedir que los clientes creen incidencias",
          "deactivate": "Desactivar unidades",
          "give_access": "Dar acceso a los clientes",
          "revoke_access": "Revocar acceso a los clientes"
        },
        "go_to_unit": "Ir a la unidad",
        "revokeAccess": "Revocar acceso",
        "select": "Seleccionar tipo",
        "selectOutdoorCategory": "Seleccionar espacio exterior",
        "selectUnit": "Seleccionar unidad",
        "setCustomer": "Asignar un cliente a",
        "setVisible": "Dar acceso",
        "submit": "Guardar",
        "update_pricing": "Actualizar precios"
      },
      "attributes": {
        "address_city": "Ciudad",
        "address_country": "País",
        "address_number": "Número",
        "address_street": "Calle",
        "address_zip": "Código postal",
        "amount": "Importe",
        "bathrooms": "Número de baños",
        "bedrooms": "Número de dormitorios",
        "category": "Tipo",
        "category_outdoor": "Espacio exterior",
        "customer": "Cliente",
        "deed_signed_at": "Fecha de firma de la escritura",
        "description": "Descripción",
        "electricity": "Electricidad",
        "floor": "Planta",
        "house_subcategory": "Tipo de vivienda",
        "internal_note": "Nota interna de la unidad",
        "meter_number": "Número de contador",
        "meter_number_electricity": "Número de contador de electricidad",
        "meter_number_gas": "Número de contador de gas",
        "meter_number_warmth": "Número de contador de calefacción",
        "meter_number_water": "Número de contador de agua",
        "meter_numbers": "Números de contador",
        "name": "Nombre",
        "orientation": "Orientación",
        "price_value": "Valor total de venta",
        "price_value_construction": "Valor de construcción",
        "price_value_construction_existing": "Costes de la construcción existente",
        "price_value_fees": "Honorarios de arquitectura/ingeniería",
        "price_value_land": "Valor del suelo",
        "quotity": "Parte del importe de transmisión",
        "sales_employee": "Comercial",
        "surface_garden": "Superficie del jardín",
        "surface_terrace": "Superficie de la terraza",
        "surface_total": "Superficie total",
        "tax_percentage": "% de impuestos",
        "toilets": "Número de aseos",
        "total": "Total",
        "vat_percentage": "% de IVA"
      },
      "house_subtype": {
        "detached": "Vivienda unifamiliar aislada",
        "rowhouse": "Vivienda adosada",
        "semidetached": "Vivienda pareada"
      },
      "labels": {
        "activate": "Activar",
        "address": "Dirección",
        "areYouSureDeactivate": "¿Seguro que quieres desactivar {unit_name}?",
        "bathrooms": "baño | baños",
        "bedrooms": "dormitorio | dormitorios",
        "cannot_activate_all_units": "No te quedan unidades suficientes para activar todas las unidades seleccionadas",
        "customer_can_create_issue_project_off": "Desactivado para todo el proyecto en la configuración del proyecto.",
        "customer_issue_creation_unit_off": "Ya no puedes notificar incidencias para esta unidad.",
        "deactivate": "Desactivar",
        "deactivateMessage": "El cliente podrá seguir comunicándose contigo y seguirá teniendo acceso a toda su información. Sin embargo, no será posible realizar otras acciones para {unit_name}, como crear decisiones, subir documentos o enviar encuestas.",
        "deactivated": "Desactivada",
        "notAvailableDeactivated": "No disponible para una unidad desactivada",
        "deedSignedOn": "Escritura firmada el {date}",
        "deedWillBeSignedOn": "La escritura se firmará el {date}",
        "detailed_price": "Detallado",
        "details": "Detalles",
        "email_address_secondary_delivery_content": "recibe correos de notificación como antiguo contacto secundario",
        "email_address_secondary_delivery_tip": "Este cliente se añadió originalmente como contacto secundario del otro cliente, antes de que se introdujera la compatibilidad con varios clientes por unidad: este cliente seguirá recibiendo los mismos correos de notificación que el otro cliente, pero solo el otro cliente tiene acceso a la unidad/inicio de sesión.",
        "existingVatValues": "Algunos valores de IVA son distintos de 0",
        "export": "Exportar",
        "export_preparing": "Recopilar los datos de la unidad puede tardar unos segundos.",
        "facing": "Orientado hacia {direction}",
        "fromATotal": "Total del proyecto: {total}",
        "general": "General",
        "howDoesCustomerSeeThis": "¿Cómo ve el cliente su unidad?",
        "integrationNoCustomerAssigned": "No hay clientes asignados. Asigna clientes en {integration_name}.",
        "internal": "Interno",
        "internalDisclaimer": "Esta información solo es visible para tu equipo",
        "invitationAddEmailAddress": "Para dar acceso a la unidad a {customer}, primero rellena la dirección de correo en la página de contacto del cliente.",
        "invitationAddEmailAddress_SUP": "Para dar acceso al proyecto a {customer}, primero rellena la dirección de correo en la página de contacto del cliente.",
        "invitationSentTo": "{customer} recibirá su invitación en breve en {email}",
        "maintainerNoCustomerAssigned": "No hay ningún cliente asignado. Solo los miembros del equipo con el rol de «Propietario» pueden asignar un cliente a una unidad.",
        "more": "más",
        "onFloor": "En la planta",
        "or_create_new": "Crear nuevo",
        "other_units": "Tiene otras unidades",
        "price_view": "Vista de precios",
        "sales_value": "Todos los precios están en {currency}",
        "scopes": {
          "invisible": "Sin acceso a la unidad",
          "invisible_SUP": "Sin acceso al proyecto",
          "visible": "Tiene acceso",
          "visible_SUP": "Tiene acceso"
        },
        "scopes_description": {
          "invisible": "El cliente todavía no tiene acceso a esta unidad en el portal del cliente",
          "invisible_SUP": "El cliente todavía no tiene acceso a este proyecto en el portal del cliente",
          "visible": "El cliente tiene acceso a esta unidad en el portal del cliente",
          "visible_SUP": "El cliente tiene acceso a esta unidad en el portal del cliente"
        },
        "search_unit": "Buscar unidad o cliente…",
        "selectUnit": "Seleccionar una unidad",
        "select_contact_required": "Selecciona primero un contacto",
        "select_existing_contact": "Existente",
        "set_unit_price": "Establecer el precio de la unidad",
        "showUnit": "Mostrar unidad",
        "simple_price": "Simple",
        "toggleDetailedPrice": "Cambiar vista de precios",
        "unassigned": "Sin cliente asignado",
        "unit": "Ninguna unidad | Una unidad | {count} unidades",
        "unitLabel": "Unidad",
        "units": "Unidades",
        "units_assigned_count": "{assigned} / {total} unidades",
        "units_not_added": "{count} unidad aún no añadida | {count} unidades aún no añadidas",
        "utilities": "Suministros",
        "visibleCustomer": "Esta información es visible para los clientes"
      },
      "outdoor_category": {
        "balcony": "Balcón",
        "garden": "Jardín",
        "null": "Ninguno",
        "terrace": "Terraza",
        "terrace_garden": "Terraza + jardín"
      },
      "status": {
        "unavailable": "No disponible"
      },
      "toasts": {
        "activateSuccess": "{unit_name} se ha activado correctamente",
        "create_fixed": "Unidad creada",
        "create_rundle": "Nueva unidad activa creada. Queda 1 unidad activa. | Nueva unidad activa creada. Quedan {count} unidades activas.",
        "deactivateSuccess": "{unit_name} se ha desactivado correctamente",
        "delete": "Unidad eliminada",
        "update": "Unidad actualizada"
      },
      "type": {
        "alf": "Residencia asistida",
        "apartment": "Piso",
        "cellar": "Sótano",
        "commercial": "Local comercial",
        "duplex": "Dúplex",
        "house": "Casa",
        "loft": "Loft",
        "office": "Oficina",
        "penthouse": "Ático",
        "sme": "Unidad pyme",
        "studio": "Estudio"
      },
      "validation": {
        "needName": "Se requiere un título",
        "needNumber": "Debe ser un número (p. ej. 85)",
        "pricesNotUpdatable": "Algunos o todos los precios se han usado en cuotas y, por tanto, no se pueden editar. Elimina las cuotas asociadas para poder editar los precios de nuevo",
        "totalSalesValueNotEqualToParts": "Parece que el valor total de venta no coincide con la suma de sus partes"
      }
    }
  }
}
